import type { IInsertScheduledEmailRequest, IScheduledEmail } from '@/types/email.types';
import { Delete, Get, Post, Put } from '../helpers';

export async function CreateScheduledEmail(email: IInsertScheduledEmailRequest) {
  return Post({ path: '/v3/admin/scheduled-emails', body: { scheduledEmail: email } });
}

export async function EditScheduledEmail(email: IScheduledEmail) {
  const params = new URLSearchParams();
  if (localStorage.getItem('blp-force-fail') === 'true') {
    params.append('fail', '1');
  }
  return Put<IScheduledEmail>({
    path: `/v3/admin/scheduled-emails?${params.toString()}`,
    body: { editScheduledEmail: email },
  });
}

export async function EditScheduledEmailWorkingContent(email: IScheduledEmail | IInsertScheduledEmailRequest) {
  return Put({ path: '/v3/admin/scheduled-emails/working-content', body: { editScheduledEmail: email } });
}

export async function DeleteScheduledEmail(scheduleUuid: IScheduledEmail['uuid']) {
  return Delete({ path: `/v3/admin/scheduled-emails/${scheduleUuid}` });
}

export async function GetEventScheduledEmails(event_uuid: string) {
  return Get({ path: `/v3/admin/scheduled-emails/event-emails/${event_uuid}` });
}

export async function GetChannelScheduledEmails(channel: number) {
  return Get({ path: `/v3/admin/scheduled-emails/channel-emails/${channel}` });
}

export async function SendTestEmail(
  emailAddresses: string[],
  scheduledEmail: IScheduledEmail,
  eventUuid: string,
  channel: number
) {
  return Post({
    path: `/v3/admin/scheduled-emails/test-email`,
    body: { emailAddresses, scheduledEmail, eventUuid, channel },
  });
}
